import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {useI18n} from '../../../../../../data/hooks/i18nHooks';
import Tab from '../../../../../elements/Tabs/Tab';
import {isActiveParticipantsFilterTabSelected} from './isActiveParticipantsFilterTabSelected';

const ACTIVE_PARTICIPANTS_FILTER = {
    active: true,
};

function ActiveParticipants(props) {
    const {className = '', eventId, filterParams} = props,
        i18n = useI18n(),
        selected = isActiveParticipantsFilterTabSelected(filterParams),
        dispatch = useDispatch();

    const handleClick = useCallback(() => {
        dispatch(app.actions.participants.setFilterParams(eventId, ACTIVE_PARTICIPANTS_FILTER));
    }, [eventId]);

    return (
        <Tab className={className} selected={selected} onClick={handleClick}>
            {i18n['label.tab.active']}
        </Tab>
    );
}

export default ActiveParticipants;
